import React from 'react';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { postOpenCashDrawer } from './business-logic/service/post-open-cash-drawer';
import { openDrawer } from 'src/cash-office-display/components/cash-drawer-actions';

import {
  AuthenticationModal,
  IAuthenticationModalProps,
} from '../common/components/authentication-modal/authentication-modal';
import XLRLogger from 'src/common/helpers/logger';
import { useTranslation } from 'react-i18next';

export const showOpenCashDrawerModal = (): void => {
  pushEmeraldModal(<OpenCashDrawerModal />);
};

export const OpenCashDrawerModal = (): JSX.Element => {
  const { t } = useTranslation();
  const errorMessage = t('OpenCashDrawerFormError');

  const onCancel = (): void => {
    popEmeraldModal();
  };

  const onSubmit = async (
    userName: string,
    password: string,
    setError: (err: string) => React.Dispatch<React.SetStateAction<string | undefined>>,
    isButtonDisabled: (
      buttonDisabled: boolean,
    ) => React.Dispatch<React.SetStateAction<boolean | false>>,
  ): Promise<void> => {
    try {
      await postOpenCashDrawer({ userName, password });
      openDrawer();
      popEmeraldModal();
    } catch {
      setError(errorMessage);
      isButtonDisabled(true);
      XLRLogger.error({
        message: errorMessage,
        source: 'open-cash-drawer-modal.tsx',
      });
    }
  };

  const modalProps: IAuthenticationModalProps = {
    onSubmit: onSubmit,
    onCancel: onCancel,
    title: 'OpenCashDrawerCommand',
    dataTestId: 'open-cash-drawer',
    usernameLabel: 'UserIdLabel',
    passwordLabel: 'UserPassword',
    submitLabel: 'OpenCashDrawerSubmitButtonLabel',
    cancelLabel: 'Cancel',
  };

  return <AuthenticationModal {...modalProps} />;
};
